import { useCallback } from 'react';

import { setScrollCoordinates } from '@/apps/mwd-v2/state/actions/scrollCoordinates';
import useClientState from '@/state/useClientState';

const useMiniMwdChart = () => {
  const miniMwdHeight = useClientState((state) => state.miniMwd.height);
  const miniMwdWidth = useClientState((state) => state.miniMwd.width);
  const miniMwdWidthPerHour = useClientState((state) => state.miniMwd.widthPerHour);

  const scrollEventHandler = useCallback(
    (event: React.UIEvent<HTMLDivElement, UIEvent>) => {
      setScrollCoordinates(
        event.currentTarget.scrollLeft,
        event.currentTarget.scrollTop,
        event.currentTarget.offsetWidth,
      );
    },
    [miniMwdWidthPerHour],
  );

  return {
    scrollEventHandler,
    miniMwdHeight,
    miniMwdWidth,
  };
};
export default useMiniMwdChart;
